'use strict';

function togglePassword($compile) {
  return {
    restrict: 'A',
    scope: {},
    link: function(scope, elem){
      scope.typeDefault = elem.attr('type');
      scope.tgl = function(){
        elem.attr('type', (elem.attr('type')==='text' ? 'password' : 'text'));
        scope.typeDefault = elem.attr('type');
      };
      var lnk = angular.element('<button class="button keypass__icon-password keypass__icon-copy icon-only" ng-click="tgl()" ng-class="{\'active\': typeDefault == \'text\'}" type="button"><i ng-show="typeDefault == \'text\'" class="fa fa-eye-slash" aria-hidden="true"></i><i ng-show="typeDefault == \'password\'" class="fa fa-eye" aria-hidden="true"></i></button>');
      $compile(lnk)(scope);
      elem.after(lnk);
    }
  };
}

angular.module('dokiv')
  .directive('togglePassword', ['$compile', togglePassword]);


//////////////////
// WEBPACK FOOTER
// ./scripts/app/TogglePasswordDirective.js
// module id = 252
// module chunks = 0